export default __webpack_public_path__ + "static/media/button-play-store.8253b0c7.svg";